/* eslint-disable array-callback-return */
/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { useParams, useHistory } from 'react-router-dom'
import { WebApi } from '../../../api/web'
import CalendarPage from './calendar'
import { userId } from '../../../services/authentication'

const CalendarLawyer = () => {
  const router = useHistory()
  const { id } = useParams()
  const [lawyer, setLawer] = useState(null)
  const [like, setLike] = useState(false)
  const [loading, setLoading] = useState(false)
  const [countLike, setCountLike] = useState(0)

  useEffect(() => {
    getLawyer()
  }, [])

  const getLawyer = async () => {
    await WebApi.lawyer(id)
      .then((res) => {
        if (!Boolean(res.data.data.lawyer.isBought)) {
          router.goBack()
        } else {
          setLawer(res.data.data.lawyer)
          setCountLike(res.data.data.lawyer.likes.length)
          res.data.data.lawyer.likes.map((userLike) => {
            if (userLike == userId()) {
              setLike(true)
            }
          })
        }
      })
      .catch((err) => {
        console.log('err', err)
      })
  }

  const LikeDisLike = async () => {
    setLoading(true)
    await WebApi.likeDislike(id)
      .then((res) => {
        setLoading(false)
        if (res.data.data.likeLawyer.message == '1') {
          setCountLike(countLike + 1)
          setLike(true)
        } else {
          setCountLike(countLike - 1)
          setLike(false)
        }
      })
      .catch((err) => {
        setLoading(false)
      })
  }

  return (
    <>
      <CalendarPage
        {...{ loading, lawyer, like, LikeDisLike, countLike, id }}
      />
    </>
  )
}
export default CalendarLawyer
